import { Link, Stack } from "@mui/material";
import { usePermissions } from "context/permissionContenxt";
import propTypes from "prop-types";

const API_BASE_URL = (import.meta.env.VITE_REACT_APP_BASE_URL ?? "").replace(
  /\/$/,
  "",
);

const EXPENSE_ENTRY_GUIDE_FILE =
  "ΠΣ ΜΗΔ - Οδηγίες Χρήσης για την Καταχώρηση Δαπανών Προγράμματος ΜΗΔ για Φορείς.PDF";
const EXPENSE_REVIEW_GUIDE_FILE =
  "ΠΣ ΜΗΔ - Οδηγίες Χρήσης για τον Έλεγχο Δαπανών Προγράμματος ΜΗΔ από την Υπηρεσία.PDF";

const REVIEWER_PERMISSIONS = [
  { action: "View", subject: "MHD_GovnrExpenses" },
  { action: "Review", subject: "MHD_GovnrTransHeaderExpenses" },
  { action: "View", subject: "MHD_GovnrTransHeaderExpenses" },
];

const getGuideUrl = (fileName) =>
  `${API_BASE_URL}/${encodeURIComponent(fileName)}`;

const canAny = (permissions, requiredPermissions) =>
  requiredPermissions.some(({ action, subject }) =>
    permissions.can(action, subject),
  );

const guideLinkSx = {
  fontSize: 13,
  fontWeight: 700,
  lineHeight: 1.25,
  overflowWrap: "anywhere",
  textAlign: { xs: "left", sm: "right" },
  textDecoration: "underline",
};

const ExpenseGuideLinks = ({
  alignItems = { xs: "flex-start", sm: "center" },
  direction = { xs: "column", sm: "row" },
  justifyContent = "flex-end",
  linkSx,
  spacing = { xs: 0.5, sm: 2 },
  sx,
}) => {
  const permissions = usePermissions();
  const sxList = Array.isArray(sx) ? sx : [sx].filter(Boolean);
  const linkSxList = Array.isArray(linkSx) ? linkSx : [linkSx].filter(Boolean);
  const canViewReviewerGuide = canAny(permissions, REVIEWER_PERMISSIONS);
  const canViewEntryGuide =
    permissions.can("View", "MHD_Expenses") || canViewReviewerGuide;

  if (!canViewEntryGuide && !canViewReviewerGuide) return null;

  return (
    <Stack
      direction={direction}
      spacing={spacing}
      alignItems={alignItems}
      justifyContent={justifyContent}
      sx={[{ width: "100%" }, ...sxList]}
    >
      {canViewEntryGuide && (
        <Link
          href={getGuideUrl(EXPENSE_ENTRY_GUIDE_FILE)}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={[guideLinkSx, ...linkSxList]}
        >
          Οδηγός Χρήσης Εισαγωγής Δαπανών
        </Link>
      )}
      {canViewReviewerGuide && (
        <Link
          href={getGuideUrl(EXPENSE_REVIEW_GUIDE_FILE)}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={[guideLinkSx, ...linkSxList]}
        >
          Οδηγός Χρήσης Ελέγχου Δαπανών
        </Link>
      )}
    </Stack>
  );
};

ExpenseGuideLinks.propTypes = {
  alignItems: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
  ]),
  direction: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
  ]),
  justifyContent: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
  ]),
  linkSx: propTypes.oneOfType([
    propTypes.array,
    propTypes.func,
    propTypes.object,
  ]),
  spacing: propTypes.oneOfType([
    propTypes.number,
    propTypes.object,
    propTypes.string,
  ]),
  sx: propTypes.oneOfType([
    propTypes.array,
    propTypes.func,
    propTypes.object,
  ]),
};

export default ExpenseGuideLinks;
